import { FC } from "react";
import { Box, Button, TextField, Typography } from "mui";
import { useFormik } from "formik";

import styles from "modules/Auth/components/AuthenticationForm/AuthenticationForm.module.scss";
import { useAppDispatch, useAppSelector } from "utils/hooks/storeHooks";
import { twoFactorAuthSession } from "store/session/thunks";
import { selectLogInStatus } from "store/session/selectors";
import { SessionStatus } from "types/Session";
import { LoginStep } from "constants/loginSteps";
import { useNavigate } from "react-router-dom";

interface AuthenticationFormProps {
  onSend: (value: LoginStep) => void;
  onGoBack: (event?: BeforeUnloadEvent) => void;
}

const AuthenticationForm: FC<AuthenticationFormProps> = ({
  onSend,
  onGoBack,
}: AuthenticationFormProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loginStatus = useAppSelector(selectLogInStatus);
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    onSubmit: (values) => {
      dispatch(twoFactorAuthSession(values.password));
      if (loginStatus === SessionStatus.fulfilled) {
        onSend(LoginStep.End);
      }
    },
  });

  return (
    <Box>
      <Box>
        <h1>Two Factor Authentication</h1>
      </Box>
      <Box className={styles.description}>
        <Typography variant="subtitle1">
          Open the two-step verification app on your mobile device to get your 6 digits
          verification code.
        </Typography>
      </Box>

          <form onSubmit={formik.handleSubmit}>
            <Box className={styles.codeField}>
              <TextField
                className={styles.textInput}
                label="Please enter code here"
                name="password"
                variant="outlined"
                autoFocus={true}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </Box>
            <Button
              className={styles.verificationButton}
              variant="contained"
              type="submit"
            >
              Verify Code
            </Button>
            <Button
              className={styles.goBackLogin}
              variant="outlined"
              type="button"
              onClick={() => {
                onGoBack();
                navigate("/");
              }}
            >
              Go back to login
            </Button>
          </form>

    </Box>
  );
};

export default AuthenticationForm;
